import { createContext, useContext } from 'react';
import type { ApiArticleDetail } from './api';

/**
 * The article a page is currently showing, if it is showing one.
 *
 * An article detail page is composed from sections like every other page - an editor
 * picks them on the page marked as the article layout. Those sections then have to know
 * which article they are wrapping: `article-body` renders it, and `news-teaser`
 * and `news-teaser` have to leave it out of their own lists rather than linking the
 * reader back to the page they are already on.
 *
 * `null` on every ordinary page, which is why sections must cope with its absence
 * rather than assume it.
 */
export const CurrentArticleContext = createContext<ApiArticleDetail | null>(null);

export function useCurrentArticle(): ApiArticleDetail | null {
  return useContext(CurrentArticleContext);
}
